export const Map = () => {
    return (
        <svg fill="currentColor" aria-current="true" viewBox="0 0 59 65">
            <path
                d="M44 .773V59.06l10.198 3.922c2.246.864 4.66-.794 4.66-3.2V8.842c0-1.418-.875-2.69-2.199-3.2zM14.857.773V59.06l14.858 5.714V6.488z"
                opacity=".5"
            />
            <path d="M29.714 6.488v58.285L44 59.06V.773zM2.198 5.642A3.429 3.429 0 0 0 0 8.842v50.94c0 2.405 2.414 4.063 4.66 3.2l10.197-3.923V.773z" />
        </svg>
    );
};
